import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { TestimonialInterface } from '@app/interfaces/testimonial.interface';
import { getCacheBustedParams } from '@app/utilities/_index';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class WordpressTestimonialsService extends ErrorHandlerService {
  private testimonialsUrl = `${environment.cms.url}/wp-json/wp/v2/testimonials`;
  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Return testimonial by page view
   * @param view - view string that filters testimonials by view
   * @returns - returns a observable array of testimonials
   */
  getTestimonialsByView(view: string): Observable<TestimonialInterface[]> {
    const testimonialPageURLParams = getCacheBustedParams()
      .append('view', view)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);

    return this.http
      .get<TestimonialInterface[]>(`${this.testimonialsUrl}`, { params: testimonialPageURLParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<any[]>('getTestimonialsByView', []))
      );
  }
}
